<ng-container *ngIf="data.tenant_id">
    <button mat-mini-fab class="product-card-action" (click)="onClick($event)" matTooltip="Внести покупку"
        [buttonLoading]="loading">
        <mat-icon>add_shopping_cart</mat-icon>
    </button>
</ng-container>